export enum TasState {
    NotActive = -1,
    NotWorking = 0,
    Working = 1,
    OnCallDuty = 2,
    Break = 3,
}
  
export enum WorkShiftLocationEntryType {
    WorkShiftStart = 10,
    WorkShiftEnd = 11,
}
  
export enum VacationType {
    PaylessLeave = 0,
    PayLeave = 1,
    AnnualLeave = 2,
    SickLeave = 3,
    FlexiLeave = 4,
}
